import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AppDownload = () => {
  const [showComingSoonPopup, setShowComingSoonPopup] = useState(false);

  const handleAppStoreClick = () => {
    window.open('https://apps.apple.com/pt/app/am-cardmate/id6747951046', '_blank');
  };

  const handleGooglePlayClick = () => {
    window.open('https://play.google.com/store/apps/details?id=com.amcardmate.app', '_blank');
  };

  return (
    <section id="app-download" className="py-12 sm:py-16 md:py-20 lg:py-24 bg-gradient-to-b from-white via-gray-50 to-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 sm:w-96 sm:h-96 bg-purple-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <div className="badge badge-blue inline-flex mb-4">
            <FontAwesomeIcon icon="mobile-alt" />
            <span>Available on iOS & Android</span>
          </div>
          
          <h2 className="text-h2 mb-4 text-dark">
            Download <span className="text-gradient-blue-pink">AM CARDMATE</span> Today
          </h2>
          
          <p className="text-body-lg text-gray max-w-2xl mx-auto">
            Join thousands of professionals transforming how they network
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <div className="bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 rounded-2xl sm:rounded-3xl p-4 sm:p-6 lg:p-8 xl:p-12 shadow-xl">
            <div className="space-y-8 lg:space-y-0">
              <div className="flex justify-center lg:hidden">
                <div className="relative w-full max-w-[280px] xs:max-w-[320px] sm:max-w-[350px]">
                  <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-[2rem] sm:rounded-[3rem] p-1.5 sm:p-2 shadow-2xl">
                    <div className="bg-black rounded-[1.8rem] sm:rounded-[2.8rem] p-0.5 sm:p-1">
                      <div className="bg-white rounded-[1.6rem] sm:rounded-[2.6rem] overflow-hidden">
                        <img 
                          src="/assets/phone.jpg"
                          alt="AM CARDMATE App" 
                          className="w-full h-[350px] xs:h-[400px] sm:h-[450px] object-cover object-top"
                        />
                      </div>
                    </div>
                    <div className="absolute top-3 sm:top-4 left-1/2 -translate-x-1/2 w-16 sm:w-24 h-3 sm:h-5 bg-gray-900 rounded-full"></div>
                  </div>
                  
                  <div className="absolute -top-1 sm:-top-2 -right-1 sm:-right-2 bg-white rounded-lg sm:rounded-xl shadow-lg p-2 sm:p-3 max-w-[140px] sm:max-w-none">
                    <div className="flex items-center gap-2">
                      <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center flex-shrink-0">
                        <FontAwesomeIcon icon="check" className="text-white text-xs sm:text-sm" />
                      </div>
                      <div>
                        <p className="text-label text-dark">Card Shared</p>
                        <p className="text-caption">Just now</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="absolute -bottom-1 sm:-bottom-2 -left-1 sm:-left-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg sm:rounded-xl px-2 sm:px-4 py-1 sm:py-2 text-btn-sm shadow-lg">
                    <FontAwesomeIcon icon="qrcode" className="mr-1 sm:mr-2" />
                    <span className="hidden xs:inline">Scan to Connect</span>
                    <span className="xs:hidden">Scan</span>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-8 xl:gap-12 items-start lg:items-center">
                <div className="space-y-4 sm:space-y-6">
                  <div>
                    <h3 className="text-h4 text-dark mb-3 sm:mb-4 text-center lg:text-left">
                      Everything You Need
                    </h3>
                    
                    <div className="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-1 gap-2 sm:gap-3">
                      {[
                        { icon: 'palette', text: 'Professional Templates', color: 'text-blue-600' },
                        { icon: 'share-nodes', text: 'Instant Sharing', color: 'text-purple-600' },
                        { icon: 'address-book', text: 'Contact Management', color: 'text-pink-600' },
                        { icon: 'chart-simple', text: 'Powerful Analytics', color: 'text-indigo-600' },
                        { icon: 'wifi', text: 'NFC Technology', color: 'text-green-600' },
                        { icon: 'lock', text: 'Secure & Private', color: 'text-red-600' }
                      ].map((item, index) => (
                        <div key={index} className="flex items-center gap-2 sm:gap-3">
                          <div className={`w-7 h-7 sm:w-8 sm:h-8 bg-white rounded-lg flex items-center justify-center shadow-sm flex-shrink-0`}>
                            <FontAwesomeIcon icon={item.icon} className={`${item.color} text-sm`} />
                          </div>
                          <span className="text-body-sm text-gray-700 font-medium">{item.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="text-center flex flex-col justify-center items-center h-full">
                        <div className="text-h4 text-gradient-blue-pink mb-1">Trusted</div>
                        <p className="text-caption">by Professionals</p>
                      </div>
                      <div className="text-center flex flex-col justify-center items-center h-full">
                        <div className="flex items-center justify-center gap-1 mb-1">
                          {[...Array(5)].map((_, i) => (
                            <FontAwesomeIcon key={i} icon="star" className="text-yellow-500 text-xs sm:text-sm" />
                          ))}
                        </div>
                        <p className="text-caption">4.9 Rating</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="hidden lg:block relative mx-auto">
                  <div className="relative w-[280px] xl:w-[350px] mx-auto">
                    <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-[3rem] p-2 shadow-2xl">
                      <div className="bg-black rounded-[2.8rem] p-1">
                        <div className="bg-white rounded-[2.6rem] overflow-hidden">
                          <img 
                            src="/assets/phone.jpg"
                            alt="AM CARDMATE App" 
                            className="w-full h-[400px] xl:h-[500px] object-cover object-top"
                          />
                        </div>
                      </div>
                      <div className="absolute top-4 left-1/2 -translate-x-1/2 w-24 h-5 bg-gray-900 rounded-full"></div>
                    </div>
                    
                    <div className="absolute -top-2 -right-2 bg-white rounded-xl shadow-lg p-3">
                      <div className="flex items-center gap-2">
                        <div className="w-8 h-8 bg-gradient-to-br from-green-400 to-green-600 rounded-full flex items-center justify-center">
                          <FontAwesomeIcon icon="check" className="text-white text-sm" />
                        </div>
                        <div>
                          <p className="text-label text-dark">Card Shared</p>
                          <p className="text-caption">Just now</p>
                        </div>
                      </div>
                    </div>
                    
                    <div className="absolute -bottom-2 -left-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl px-4 py-2 text-btn-sm shadow-lg">
                      <FontAwesomeIcon icon="qrcode" className="mr-2" />
                      Scan to Connect
                    </div>
                  </div>
                </div>

                <div className="space-y-4 sm:space-y-6">
                  <div>
                    <h3 className="text-h5 text-dark mb-3 sm:mb-4 text-center lg:text-left">
                      Get the App Now
                    </h3>
                    <div className="space-y-2 sm:space-y-3">
                      <button 
                        onClick={handleAppStoreClick}
                        className="flex items-center gap-3 bg-black text-white px-4 sm:px-6 py-3 rounded-xl sm:rounded-2xl hover:bg-gray-900 transition-all w-full"
                      >
                        <FontAwesomeIcon icon={['fab', 'apple']} className="text-lg sm:text-xl flex-shrink-0" />
                        <div className="text-left">
                          <div className="text-caption text-white/80">Download on the</div>
                          <div className="text-btn">App Store</div>
                        </div>
                      </button>
                      
                      <button 
                        onClick={handleGooglePlayClick}
                        className="flex items-center gap-3 bg-black text-white px-4 sm:px-6 py-3 rounded-xl sm:rounded-2xl hover:bg-gray-900 transition-all w-full"
                      >
                        <FontAwesomeIcon icon={['fab', 'google-play']} className="text-lg sm:text-xl flex-shrink-0" />
                        <div className="text-left">
                          <div className="text-caption text-white/80">GET IT ON</div>
                          <div className="text-btn">Google Play</div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-primary-blue to-primary-blue-dark rounded-xl sm:rounded-2xl p-4 sm:p-6 text-white relative overflow-hidden">
                    <div className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-white/10 rounded-full -mr-12 sm:-mr-16 -mt-12 sm:-mt-16"></div>
                    <div className="relative z-10">
                      <div className="flex items-center gap-2 sm:gap-3 mb-3">
                        <div className="w-10 h-10 sm:w-12 sm:h-12 bg-white/20 backdrop-blur rounded-lg sm:rounded-xl flex items-center justify-center">
                          <FontAwesomeIcon icon="gift" className="text-lg sm:text-xl" />
                        </div>
                        <div>
                          <p className="text-body font-bold">Special Offer</p>
                          <p className="text-body-sm opacity-90">Limited Time</p>
                        </div>
                      </div>
                      <h4 className="text-h5 mb-2">Free NFC Card</h4>
                      <p className="text-body-sm opacity-90 mb-3">
                        Get a premium NFC card worth £19.99 with Lifetime plan
                      </p>
                      <a href="/nfc-cards" className="inline-flex items-center gap-2 text-white text-btn-sm hover:underline">
                        <span>View Cards</span>
                        <FontAwesomeIcon icon="arrow-right" />
                      </a>
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-2">
                    {[
                      { icon: 'shield-alt', text: 'Secure' },
                      { icon: 'bolt', text: 'Fast' },
                      { icon: 'headset', text: 'Support' }
                    ].map((item, index) => (
                      <div key={index} className="bg-white rounded-lg p-2 sm:p-3 text-center shadow-sm">
                        <FontAwesomeIcon icon={item.icon} className="text-gray-600 mb-1 text-sm sm:text-base" />
                        <p className="text-caption">{item.text}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 sm:mt-12 max-w-5xl mx-auto">
          <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm p-4 sm:p-6">
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
              {[
                { icon: 'rocket', title: 'Quick Setup', desc: 'Under 60 seconds' },
                { icon: 'infinity', title: 'Unlimited Updates', desc: 'Change anytime' },
                { icon: 'globe', title: 'Works Everywhere', desc: 'No app needed to view' },
                { icon: 'chart-line', title: 'Track Performance', desc: 'Detailed insights' }
              ].map((item, index) => (
                <div key={index} className="text-center">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg sm:rounded-xl flex items-center justify-center text-gray-700 mx-auto mb-2">
                    <FontAwesomeIcon icon={item.icon} className="text-sm sm:text-base" />
                  </div>
                  <h4 className="text-label text-dark mb-1">{item.title}</h4>
                  <p className="text-caption">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {showComingSoonPopup && (
        <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setShowComingSoonPopup(false)}>
          <div className="bg-white rounded-3xl p-6 sm:p-8 max-w-md w-full shadow-2xl" onClick={(e) => e.stopPropagation()}>
            <div className="text-center">
              <div className="w-16 sm:w-20 h-16 sm:h-20 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <FontAwesomeIcon icon="rocket" className="text-white text-2xl sm:text-3xl" />
              </div>
              
              <h3 className="text-h3 text-dark mb-4">Download AM CARDMATE</h3>
              <p className="text-body text-gray mb-8">
                AM CARDMATE is available on both App Store and Google Play!
              </p>
              
              <div className="grid grid-cols-1 gap-3 mb-6">
                <button 
                  onClick={handleAppStoreClick}
                  className="flex items-center gap-4 bg-black px-6 py-4 rounded-xl hover:bg-gray-900 transition-all"
                >
                  <FontAwesomeIcon icon={['fab', 'apple']} className="text-3xl text-white" />
                  <div className="text-left text-white">
                    <div className="text-caption text-white/80">Download on the</div>
                    <div className="text-btn-lg">App Store</div>
                  </div>
                </button>
                
                <button 
                  onClick={handleGooglePlayClick}
                  className="flex items-center gap-4 bg-black px-6 py-4 rounded-xl hover:bg-gray-900 transition-all"
                >
                  <FontAwesomeIcon icon={['fab', 'google-play']} className="text-3xl text-white" />
                  <div className="text-left text-white">
                    <div className="text-caption text-white/80">GET IT ON</div>
                    <div className="text-btn-lg">Google Play</div>
                  </div>
                </button>
              </div>
              
              <div className="space-y-3">
                <button className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl text-btn hover:from-blue-600 hover:to-purple-700 transition-all" onClick={() => setShowComingSoonPopup(false)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AppDownload;